<template>
  <div class="editor-section">
    <div class="form-group">
      <label class="form-label required-label">圖片</label>
      <ImageUploader
        :modelValue="modelValue.originalContentUrl"
        @update:modelValue="onMainImageModelValue"
        :upload-fn="uploadMainWithAutoPreview"
        skip-emit-after-success
        shape="card"
        preview-natural-ratio
        accept="image/jpeg,image/png"
        placeholder="上傳圖片"
        hint="僅支援 JPEG / PNG（LINE 不接受 WebP）"
        size-hint="主圖最大 10MB。預覽縮圖會自動從主圖產生（最長邊 240px、≤1MB）並上傳"
        :max-size-mb="10"
      />
    </div>
  </div>
</template>

<script setup>
import ImageUploader from '@/components/ImageUploader.vue';
import { lineMsgTemplateService } from '@/api/modules/lineMsgTemplates.js';
import { resampleImageFileToJpeg } from '@/utils/imageResample.js';

const props = defineProps({ modelValue: { type: Object, required: true } });
const emit = defineEmits(['update:modelValue']);

/** 上傳主圖後，以前端產生縮圖再上傳，並一次寫入 original / preview */
async function uploadMainWithAutoPreview(file) {
  const mainRes = await lineMsgTemplateService.uploadImage(file);
  if (!mainRes?.success) return mainRes;

  let previewUrl = mainRes.data.fileUrl;
  try {
    const thumbFile = await resampleImageFileToJpeg(file, {
      maxEdge: 240,
      maxBytes: 1024 * 1024
    });
    const thumbRes = await lineMsgTemplateService.uploadImage(thumbFile);
    if (thumbRes?.success && thumbRes?.data?.fileUrl) {
      previewUrl = thumbRes.data.fileUrl;
    }
  } catch (e) {
    console.warn('LINE 訊息範本：自動預覽縮圖失敗，預覽欄位改用主圖 URL', e);
  }

  emit('update:modelValue', {
    ...props.modelValue,
    originalContentUrl: mainRes.data.fileUrl,
    previewImageUrl: previewUrl
  });
  return mainRes;
}

/** 移除圖片時清空主圖與預覽；其餘由 skipEmitAfterSuccess 交給 uploadFn 更新 */
function onMainImageModelValue(val) {
  if (val == null || val === '') {
    emit('update:modelValue', {
      ...props.modelValue,
      originalContentUrl: '',
      previewImageUrl: ''
    });
  }
}
</script>
